import React, { useState } from 'react'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'
import I18n from '../../resources/i18n/I18n'

const ModalCreation = ({ showModal, toggleModal, createLabel, title, item }) => {
  const [label, setLabel] = useState('')

  const handleCreateLabel = () => {
    toggleModal()
    createLabel(label)
    setLabel('')
  }

  return (
    <Modal show={showModal} onHide={toggleModal}>
      <Modal.Header closeButton>
        <Modal.Title>{title ? title : I18n.t('CreateConfirmTitle')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group>
          <Form.Label>{I18n.t('Label')}</Form.Label>
          <Form.Control defaultValue={item ? item.label : ''} onChange={(e) => setLabel(e.target.value)} />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button className="btn-back" onClick={toggleModal}>
          {I18n.t('ModalConfirmCancel')}
        </Button>
        <Button className="primary" onClick={handleCreateLabel}>
          {I18n.t('ModalConfirmOk')}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default ModalCreation
